"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { createRoot } from "../../util/create_root";
export class ElementRoot {
  constructor(host) {
    __publicField(this, "host", host);
    __publicField(this, "root", null);
    __publicField(this, "unmountQueued", false);
  }
  // A no-op while the element is detached, so attributes set before it is
  // inserted don't create a root; connectedCallback renders once it is.
  render(node) {
    var _a;
    if (!this.host.isConnected) return;
    (_a = this.root) != null ? _a : this.root = createRoot(this.host);
    this.root.render(node);
  }
  // Elm can remove the element while the main React root is committing, and
  // unmounting synchronously then logs "Attempted to synchronously unmount a
  // root while React was already rendering". Deferred, a reconnect in the
  // meantime keeps the root.
  unmountSoon() {
    if (!this.root || this.unmountQueued) return;
    this.unmountQueued = true;
    queueMicrotask(() => {
      this.unmountQueued = false;
      if (this.host.isConnected || !this.root) return;
      this.root.unmount();
      this.root = null;
    });
  }
}
